import http from '@/utils/httpRequest'
import { useUserStore } from '@/stores/user'

// 获取投票列表
export function getVoteList() {
  return http.get('/votes')
}

// 获取投票详情
export async function getVoteDetail(id) {
  console.log('API: 发送获取投票详情请求, ID:', id)
  try {
    const response = await http.get(`/votes/${id}`)
    console.log('API: 服务器响应:', response)
    return response
  } catch (error) {
    console.error('API: 请求失败:', error)
    throw error
  }
}

// 创建投票
export function createVote(data) {
  return http.post('/votes', data)
}

// 投票
export function castVote(voteId, optionId) {
  return http.post(`/votes/${voteId}/cast?optionId=${optionId}`)
}

// 收藏/取消收藏
export function toggleFavorite(voteId) {
  return http.post(`/votes/${voteId}/favorite`)
}

// 获取用户收藏列表
export function getUserFavorites() {
  return http.get('/votes/favorites')
}

// 获取用户今日投票次数
export function getUserVoteCount() {
  const today = new Date().toISOString().split('T')[0]
  return http.get(`/votes/count?date=${today}`)
}

// 发表评论
export function addComment(content) {
  return http.post('/comments', content)
}

// 发表回复
export function addReply(commentId, content) {
  return http.post(`/comments/${commentId}/replies`, content)
}

// 获取评论列表
export function getComments(voteId) {
  return http.get(`/votes/${voteId}/comments`)
}
